/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-12-24 16:51:24
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-24 19:33:33
 * @FilePath: /wemeet-web-activity/src/pages/payend/component/phoneInput/inputZone.tsx
 * @Description: 手机号输入
 */
import React, { memo, useState } from 'react';
import { Select } from '@tencent/tea-component';
import { countryData } from "./countryData";
import styles from "./index.module.scss";
import classnames from 'classnames';
const SEPARATOR = '^_^';
// 海外手机号区号
const countryCodeOptions = countryData.map(item => ({
  text: /*#__PURE__*/React.createElement("div", {
    key: `${item.country}${item.name}+${item.areaCode}${item.code_name || ''}`
    // className={styles['code-option-item']}
  }, /*#__PURE__*/React.createElement("span", {
    title: item.name
  }, item.name), /*#__PURE__*/React.createElement("span", null, "+", item.areaCode)),
  value: `${item.areaCode}${SEPARATOR}${item.code_name}`
}));
const InputZone = ({
  onChange,
  changeArea,
  className,
  showBorder,
  onBlur,
  error,
  autoFocus = true,
  value
}) => {
  const [areaCode, setAreaCode] = useState('86');
  const [areaCodeName, setAreaCodeName] = useState('CN');
  const changeAreaCode = areaCode => {
    const array = areaCode?.split(SEPARATOR);
    const code = array?.[0];
    setAreaCode(code);
    setAreaCodeName(array?.[1]);
    changeArea(code);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles['payend-input'], className || '', showBorder ? styles['payend-input-border'] : '', error ? styles.error : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "payend-input-zone"
  }, /*#__PURE__*/React.createElement(Select, {
    placeholder: areaCode,
    className: styles['phone-select'],
    type: "simulate",
    appearance: "button",
    searchable: true,
    boxSizeSync: true,
    listHeight: 300,
    options: countryCodeOptions,
    value: `${areaCode}${SEPARATOR}${areaCodeName}`,
    onChange: changeAreaCode,
    boxClassName: styles['country-code-select-box'],
    button: `+${areaCode}`,
    filter: (inputValue, option) => {
      const keyword = inputValue?.toLowerCase().trim();
      // @ts-ignore
      const name = option.text?.key?.toLowerCase();
      return name?.includes(keyword);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.divider
  }), /*#__PURE__*/React.createElement("input", {
    onChange: e => onChange?.(e.target.value),
    type: "tel",
    placeholder: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7\u7801",
    autoFocus: autoFocus,
    onBlur: onBlur,
    value: value
  })));
};
export default /*#__PURE__*/memo(InputZone);